import ReactGA from 'react-ga';

process.env.REACT_APP_GA_TAG &&
    process.env.REACT_APP_GA_TAG.length > 0 &&
    ReactGA.initialize(process.env.REACT_APP_GA_TAG);

export default ReactGA;
